import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FieldArray } from 'redux-form';
import CustomHomeTable from './CustomHomeTable';

export default class CustomHomeSection extends PureComponent {
    static propTypes = {
        currentFormValues: PropTypes.object,
        collectionOptions: PropTypes.arrayOf(PropTypes.object),
        isVerbAdmin: PropTypes.bool,
        customTab: PropTypes.string,
        globalCollectionRowOptions: PropTypes.object
    };

    handleAddCollectionSection = ({ fields, label, type, content = [], subtext = '' }) => {
        fields.unshift({ label, subtext, type, content });
    };

    render() {
        const {
            collectionOptions,
            isVerbAdmin,
            currentFormValues,
            customTab = 'customHome',
            globalCollectionRowOptions
        } = this.props;
        return (
            <div className={'row'}>
                <FieldArray
                    name={`${customTab}.categories`}
                    customTab={customTab}
                    currentFormValues={currentFormValues}
                    collectionOptions={collectionOptions}
                    handleAddCollectionSection={this.handleAddCollectionSection}
                    component={CustomHomeTable}
                    globalCollectionRowOptions={globalCollectionRowOptions}
                    isVerbAdmin={isVerbAdmin}
                />
            </div>
        );
    }
}
